import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';

const AUTOutcomeCard = ({ outcome }) => {
    const total = (outcome.expected || 0) + (outcome.unexpected || 0) + (outcome.flaky || 0) + (outcome.skipped || 0);
    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h5" mb={2}>AUT Outcome</Typography>
            <Grid container spacing={2}>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                        <Typography variant="h4" color="success.main">{outcome.expected ?? '—'}</Typography>
                        <Typography variant="caption" color="text.secondary">Expected</Typography>
                    </Paper>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                        <Typography variant="h4" color={outcome.unexpected > 0 ? 'error.main' : 'text.primary'}>
                            {outcome.unexpected ?? '—'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">Unexpected</Typography>
                    </Paper>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                        <Typography variant="h4" color={outcome.flaky > 0 ? 'warning.main' : 'text.primary'}>
                            {outcome.flaky ?? '—'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">Flaky</Typography>
                    </Paper>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Paper variant="outlined" sx={{ p: 1.5, textAlign: 'center' }}>
                        <Typography variant="h4" color="text.secondary">{outcome.skipped ?? '—'}</Typography>
                        <Typography variant="caption" color="text.secondary">Skipped</Typography>
                    </Paper>
                </Grid>
            </Grid>
            {total > 0 && (
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    Total: {total}
                </Typography>
            )}
        </Paper>
    );
};

export default function GHAWorkflowOperation(props) {
    const { operation } = props;
    const result = operation.result || {};
    const isAUT = operation.operation === 'aut';

    if (isAUT && operation.status === 'completed' && result.aut_outcome) {
        return <AUTOutcomeCard outcome={result.aut_outcome} />;
    }

    return null;
}
